import { ref, useSlots, onUpdated, onMounted, type Ref, watch } from 'vue'

/**
 * Composable to extract text from slots (compatible with Vue 2 and Vue 3)
 */
export function useSlotText(): Ref<string> {
  const slots = useSlots()
  const text = ref('')

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const extractTextFromNode = (node: any): string => {
    if (!node) return ''
    if (typeof node === 'string') return node
    if (typeof node.children === 'string') return node.children

    if (Array.isArray(node.children)) {
      return node.children
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map((child: any) => extractTextFromNode(child))
        .join('')
    }

    if (node.text) return node.text
    if (node.type === Comment || node.type === Text) return ''

    return ''
  }

  const updateText = () => {
    if (!slots.default) {
      text.value = ''

      return
    }

    const slotData = slots.default()

    if (!slotData || slotData.length === 0) {
      text.value = ''

      return
    }

    const extractedText = slotData
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((node: any) => extractTextFromNode(node))
      .join('')
      .trim()

    text.value = extractedText
  }

  onMounted(updateText)
  onUpdated(updateText)

  watch(() => slots.default?.(), updateText, { flush: 'post' })

  return text
}
